import { BaseNavbar } from '@/components/layouts/base-navbar';

export function OrgNavbar() {
  return <BaseNavbar headerStyle="fixed" />;
}
